import { Trash2 } from 'lucide-react'
import { PERMISSIONS } from '@/lib/permissions'
import { GroupActionList } from './GroupActionList'
import { GROUP_OPS_STR as S, deleteGroup } from './groupOpsApi'

/**
 * A4.32 — Chatni o'chirish. Chatni butunlay o'chiradi (qaytarib bo'lmaydi).
 * JONLI `/admin/groups` ro'yxati; mutatsiya endpoint chiqqach jonli.
 */
export function GroupDelete() {
  return (
    <GroupActionList
      screenId="A4.32"
      title={S.del}
      description={S.delNote}
      actionId="delete"
      actionLabel={S.del}
      actionIcon={<Trash2 size={13} />}
      emptyIcon={<Trash2 size={28} strokeWidth={1.5} />}
      permission={PERMISSIONS.USERS_BAN}
      danger
      successMsg={S.deleted}
      run={async (r) => {
        if (!window.confirm(S.delConfirm)) return false
        await deleteGroup(r.id)
        return true
      }}
    />
  )
}
